import { useState } from "react";
import Card from "@/components/base/Card";
import Badge from "@/components/base/Badge";

const PERIOD_DATA = {
  semana: {
    matricula: "820",
    matriculaDiff: "+0.1%",
    casos: "3",
    casosDiff: "-25%",
    cumplimiento: "100%",
    cumplimientoDiff: "0%",
    satisfaccion: "95%",
    satisfaccionDiff: "+1%",
    chartPath: "M 0 180 Q 100 170 180 160 T 350 140 T 500 120",
    chartGradPath: "M 0 180 Q 100 170 180 160 T 350 140 T 500 120 L 500 200 L 0 200 Z",
    chartLabels: ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
    categories: [
      { name: "Rendimiento de Procesos", val: "98%" },
      { name: "Cumplimiento Tiempos Mineduc", val: "95%" },
      { name: "Capacitación del Personal", val: "90%" },
      { name: "Resolución Alternativa", val: "80%" }
    ],
    tableData: [
      { area: "Convivencia Escolar", prof: "2 Encargados", casos: "1 Caso", desc: "Excelente (98%)", labelType: "primary" },
      { area: "Orientación", prof: "1 Orientadora", casos: "1 Caso", desc: "Excelente (92%)", labelType: "primary" },
      { area: "Psicología", prof: "1 Psicóloga", casos: "1 Caso", desc: "Excelente (94%)", labelType: "primary" }
    ]
  },
  mes: {
    matricula: "820",
    matriculaDiff: "+2.4%",
    casos: "14",
    casosDiff: "-10%",
    cumplimiento: "100%",
    cumplimientoDiff: "0%",
    satisfaccion: "92%",
    satisfaccionDiff: "+5%",
    chartPath: "M 0 160 Q 100 120 180 140 T 350 60 T 500 40",
    chartGradPath: "M 0 160 Q 100 120 180 140 T 350 60 T 500 40 L 500 200 L 0 200 Z",
    chartLabels: ["Ene", "Mar", "May", "Jul", "Sep", "Nov"],
    categories: [
      { name: "Rendimiento de Procesos", val: "95%" },
      { name: "Cumplimiento Tiempos Mineduc", val: "90%" },
      { name: "Capacitación del Personal", val: "85%" },
      { name: "Resolución Alternativa", val: "75%" }
    ],
    tableData: [
      { area: "Convivencia Escolar", prof: "2 Encargados", casos: "6 Casos", desc: "Excelente (95%)", labelType: "primary" },
      { area: "Orientación", prof: "1 Orientadora", casos: "5 Casos", desc: "Normal (88%)", labelType: "warning" },
      { area: "Psicología", prof: "1 Psicóloga", casos: "4 Casos", desc: "Excelente (92%)", labelType: "primary" }
    ]
  },
  ano: {
    matricula: "820",
    matriculaDiff: "+8.2%",
    casos: "84",
    casosDiff: "+15%",
    cumplimiento: "98%",
    cumplimientoDiff: "-2%",
    satisfaccion: "90%",
    satisfaccionDiff: "+3%",
    chartPath: "M 0 120 Q 100 140 180 100 T 350 80 T 500 50",
    chartGradPath: "M 0 120 Q 100 140 180 100 T 350 80 T 500 50 L 500 200 L 0 200 Z",
    chartLabels: ["2022", "2023", "2024", "2025", "2026", "Actual"],
    categories: [
      { name: "Rendimiento de Procesos", val: "92%" },
      { name: "Cumplimiento Tiempos Mineduc", val: "94%" },
      { name: "Capacitación del Personal", val: "88%" },
      { name: "Resolución Alternativa", val: "82%" }
    ],
    tableData: [
      { area: "Convivencia Escolar", prof: "2 Encargados", casos: "42 Casos", desc: "Excelente (93%)", labelType: "primary" },
      { area: "Orientación", prof: "1 Orientadora", casos: "24 Casos", desc: "Excelente (90%)", labelType: "primary" },
      { area: "Psicología", prof: "1 Psicóloga", casos: "18 Casos", desc: "Normal (87%)", labelType: "warning" }
    ]
  }
} as const;

export default function DirectorIndicadoresPage() {
  const [period, setPeriod] = useState("mes");
  const activeData = PERIOD_DATA[period as keyof typeof PERIOD_DATA];
  
  return (
    <div className="p-4 md:p-6 space-y-6 animate-fade-in-up">
      <div className="flex flex-col sm:flex-row gap-3 items-start sm:items-center justify-between">
        <div>
          <h1 className="text-xl md:text-2xl font-bold text-foreground-950">Indicadores Institucionales</h1>
          <p className="text-sm text-foreground-500 mt-0.5">Reporte consolidado de convivencia y plazos legales a nivel del establecimiento.</p>
        </div>
        <div className="flex bg-background-100 p-0.5 rounded-lg border border-background-200">
          {["semana", "mes", "ano"].map((p) => (
            <button
              key={p}
              onClick={() => setPeriod(p)}
              className={`px-3.5 py-1 rounded-md text-xs font-semibold cursor-pointer transition-colors ${
                period === p ? "bg-white text-foreground-900 shadow-sm" : "text-foreground-400 hover:text-foreground-900"
              }`}
            >
              {p === "semana" ? "Semanal" : p === "mes" ? "Mensual" : "Anual"}
            </button>
          ))}
        </div>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        
        <div className="bg-white border border-background-200/80 rounded-2xl p-4 shadow-sm relative overflow-hidden group hover:shadow-md transition-all duration-300">
          <div className="flex items-center justify-between">
            <span className="text-xs font-semibold uppercase tracking-wider text-foreground-400">Matrícula Total</span>
            <div className="w-8 h-8 rounded-xl bg-primary-50 text-primary-600 flex items-center justify-center text-lg">
              <i className="ri-team-line" />
            </div>
          </div>
          <div className="mt-3 flex items-baseline gap-2">
            <span className="text-2xl font-bold text-foreground-900">{activeData.matricula}</span>
            <span className="text-xs font-medium text-emerald-600 flex items-center gap-0.5">
              <i className="ri-arrow-up-line" /> {activeData.matriculaDiff}
            </span>
          </div>
          <p className="text-2xs text-foreground-400 mt-1">Estudiantes inscritos</p>
        </div>

        <div className="bg-white border border-background-200/80 rounded-2xl p-4 shadow-sm relative overflow-hidden group hover:shadow-md transition-all duration-300">
          <div className="flex items-center justify-between">
            <span className="text-xs font-semibold uppercase tracking-wider text-foreground-400">Casos Abiertos</span>
            <div className="w-8 h-8 rounded-xl bg-primary-50 text-primary-600 flex items-center justify-center text-lg">
              <i className="ri-folder-open-line" />
            </div>
          </div>
          <div className="mt-3 flex items-baseline gap-2">
            <span className="text-2xl font-bold text-foreground-900">{activeData.casos}</span>
            <span className="text-xs font-medium text-emerald-600 flex items-center gap-0.5">
              <i className="ri-arrow-up-line" /> {activeData.casosDiff}
            </span>
          </div>
          <p className="text-2xs text-foreground-400 mt-1">En proceso de atención</p>
        </div>

        <div className="bg-white border border-background-200/80 rounded-2xl p-4 shadow-sm relative overflow-hidden group hover:shadow-md transition-all duration-300">
          <div className="flex items-center justify-between">
            <span className="text-xs font-semibold uppercase tracking-wider text-foreground-400">Cumplimiento Legal</span>
            <div className="w-8 h-8 rounded-xl bg-primary-50 text-primary-600 flex items-center justify-center text-lg">
              <i className="ri-scales-3-line" />
            </div>
          </div>
          <div className="mt-3 flex items-baseline gap-2">
            <span className="text-2xl font-bold text-foreground-900">{activeData.cumplimiento}</span>
            <span className={`text-xs font-medium flex items-center gap-0.5 ${
              activeData.cumplimientoDiff.startsWith("-") ? "text-red-600" : "text-emerald-600"
            }`}>
              <i className="ri-arrow-up-line" /> {activeData.cumplimientoDiff}
            </span>
          </div>
          <p className="text-2xs text-foreground-400 mt-1">De oficios judiciales</p>
        </div>

        <div className="bg-white border border-background-200/80 rounded-2xl p-4 shadow-sm relative overflow-hidden group hover:shadow-md transition-all duration-300">
          <div className="flex items-center justify-between">
            <span className="text-xs font-semibold uppercase tracking-wider text-foreground-400">Satisfacción Apoderados</span>
            <div className="w-8 h-8 rounded-xl bg-primary-50 text-primary-600 flex items-center justify-center text-lg">
              <i className="ri-heart-line" />
            </div>
          </div>
          <div className="mt-3 flex items-baseline gap-2">
            <span className="text-2xl font-bold text-foreground-900">{activeData.satisfaccion}</span>
            <span className="text-xs font-medium text-emerald-600 flex items-center gap-0.5">
              <i className="ri-arrow-up-line" /> {activeData.satisfaccionDiff}
            </span>
          </div>
          <p className="text-2xs text-foreground-400 mt-1">En resoluciones de conflictos</p>
        </div>
      </div>

      {/* Charts Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <Card className="lg:col-span-2 space-y-4">
          <div className="flex items-center justify-between">
            <h3 className="font-semibold text-foreground-900">Histórico de Tendencias</h3>
            <span className="text-xs text-foreground-400">Distribución temporal de registros</span>
          </div>
          {/* Beautiful SVG Line Chart */}
          <div className="h-60 w-full flex items-end">
            <svg className="w-full h-full" viewBox="0 0 500 200" preserveAspectRatio="none">
              <defs>
                <linearGradient id="chart-grad-DirectorIndicadoresPage" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#3b82f6" stopOpacity="0.25"/>
                  <stop offset="100%" stopColor="#3b82f6" stopOpacity="0.0"/>
                </linearGradient>
              </defs>
              <path d={activeData.chartGradPath} fill="url(#chart-grad-DirectorIndicadoresPage)" />
              <path d={activeData.chartPath} fill="none" stroke="#3b82f6" strokeWidth="3" strokeLinecap="round" />
              {/* Grid Lines */}
              <line x1="0" y1="50" x2="500" y2="50" stroke="#f1f5f9" strokeDasharray="4 4" />
              <line x1="0" y1="100" x2="500" y2="100" stroke="#f1f5f9" strokeDasharray="4 4" />
              <line x1="0" y1="150" x2="500" y2="150" stroke="#f1f5f9" strokeDasharray="4 4" />
            </svg>
          </div>
          <div className="flex justify-between text-xs text-foreground-400 px-1">
            {activeData.chartLabels.map((lbl) => (
              <span key={lbl}>{lbl}</span>
            ))}
          </div>
        </Card>
        <Card className="space-y-4">
          <h3 className="font-semibold text-foreground-900">Distribución por Categorías</h3>
          <div className="space-y-4 pt-2">
            {activeData.categories.map((cat) => (
              <div key={cat.name} className="space-y-1">
                <div className="flex justify-between text-xs">
                  <span className="font-medium text-foreground-700">{cat.name}</span>
                  <span className="font-semibold text-foreground-900">{cat.val}</span>
                </div>
                <div className="w-full h-2 bg-background-100 rounded-full overflow-hidden">
                  <div className="h-full bg-primary-500 rounded-full" style={{ width: cat.val, backgroundColor: '#3b82f6' }} />
                </div>
              </div>
            ))}
          </div>
        </Card>
      </div>

      {/* Bottom Table */}
      <Card padding="none">
        <div className="p-4 border-b border-background-150 flex items-center justify-between">
          <h3 className="font-semibold text-foreground-900">Resumen Detallado</h3>
          <Badge variant="primary">KPI Actualizado</Badge>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-background-200 bg-background-50/50">
                <th className="text-left py-3.5 px-4 text-foreground-500 font-semibold text-xs uppercase tracking-wider">Área de Trabajo</th>
                <th className="text-left py-3.5 px-4 text-foreground-500 font-semibold text-xs uppercase tracking-wider">Profesionales</th>
                <th className="text-left py-3.5 px-4 text-foreground-500 font-semibold text-xs uppercase tracking-wider">Casos Asignados</th>
                <th className="text-left py-3.5 px-4 text-foreground-500 font-semibold text-xs uppercase tracking-wider">Desempeño Promedio</th>
              </tr>
            </thead>
            <tbody>
              {activeData.tableData.map((row) => (
                <tr key={row.area} className="border-b border-background-50 hover:bg-background-50/50 transition-colors">
                  <td className="py-3 px-4 font-semibold text-foreground-900">{row.area}</td>
                  <td className="py-3 px-4 text-foreground-600 text-xs">{row.prof}</td>
                  <td className="py-3 px-4 text-foreground-600 text-xs">{row.casos}</td>
                  <td className="py-3 px-4"><Badge variant={row.labelType as any}>{row.desc}</Badge></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
